import { AppMiddleware, MsgMiddleware } from '../middlewares';
import { takeLatest, takeEvery, all } from 'redux-saga/effects';
import {
  CHANGE_PASSWORD,
  LOGOUT,
  SIGNIN,
  VERIFY_2FA,
  CREATE_CHAT_CHANNEL,
  MESSAGE_CHAT_CHANNEL,
  USER_PROFILE,
  CREATE_GROUP,
  UNREAD_MESSAGE_DOT,
  DELETE_MESSAGE,
  ADD_USERS_GROUP,
  SHARE_MEDIA,
  CREATE_GROUP_ADD_ID,
  GLOBAL_SEARCH_CHATS_GROUPS,
  UPLOAD_CAHT_MEDIA,
  MISSED_CALL_HISTORY,
  RECENT_CALL_HISTORY,
  JOIN_CALL,
  START_CALL,
  REPORT_MSG,
  USERS_DATA,
  USER_PROFILE_DATA,
  MULTIPLE_CALL_USERS_DATA,
  CALL_DETAILS,
  CALL_SESSION,
  ACTIVE_GROUP_CALL,
  CREATE_THREADS,
  THREAD_LISTING,
  JOIN_THREADS,
  THREAD_DETAILS,
  UPLOAD_THREAD_MEDIA,
  THREAD_CHAT_CHANNEL,
  DELETE_USER_PROFILE,
  TOGGLE_NOTIFICATIONS,
  NOTIFICATIONS_LISTS,
  NOTIFICATIONS_UNREAD_COUNT,
  MARK_NOTIFICATIONS_READ,
  EDIT_USER_PROFILE,
  DELETE_THREAD,
  DELETE_CHANNEL,
  JOIN_GROUP,
  LEAVE_GROUP,
  GROUP_MEMBERS,
  CHANNEL_MEMBERS_PAGE,
  UPDATE_CREATE_GROUP,
  LAST_SEEN_TOGGLE,
  CREATE_CONTACT,
  DELETE_CONTACT,
  UPDATE_CONTACT,
  LIST_CONTACTS,
  PASSCODE_TOGGLE,
  VERIFY_PASSCODE,
  UPDATE_PASSCODE,
  CONTACT_SUPPORT,
  PROMOTE_CHANNEL_ADMINS,
  DEMOTE_CHANNEL_ADMIN,
  TRANSFER_CHANNEL_OWNERSHIP,
  REMOVE_CHANNEL_MEMBER,
  RETRACT_MESSAGE,
  TOGGLE_SAVE_MESSAGE,
  SAVED_MESSAGES_LIST,
  APP_LOCK_TRIGGER,
  APP_UNLOCK,
} from '../constants';

export function* Sagas() {
  yield all([
    yield takeLatest(SIGNIN, AppMiddleware.SignIn),
    yield takeLatest(VERIFY_2FA, AppMiddleware.Verify2fa),
    yield takeLatest(USER_PROFILE, AppMiddleware.UserProfile),
    yield takeLatest(USER_PROFILE_DATA, MsgMiddleware.UserProfileData),
    yield takeLatest(CHANGE_PASSWORD, AppMiddleware.ChangePassword),
    yield takeLatest(LOGOUT, AppMiddleware.Logout),
    yield takeLatest(CREATE_CHAT_CHANNEL, MsgMiddleware.CreateChatChannel),
    yield takeLatest(UPLOAD_CAHT_MEDIA, MsgMiddleware.UploadChatMedia),
    // ── Paging reads ───────────────────────────────────────────────────────────
    // takeEvery, not takeLatest. Two reasons, and either alone is sufficient:
    //
    //   • A cancelled saga puts NEITHER success nor failure, so the `*_loader: true`
    //     set by the request action is never cleared — a spinner that never resolves.
    //     A single fast scroll gesture was enough to reach this.
    //   • Cancelling page 3 because page 4 was asked for silently discards page 3's
    //     rows. `takeLatest` means "only the last answer matters", which is true of a
    //     search box and false of a list being extended.
    //
    // The search-driven reads below (`GLOBAL_SEARCH_CHATS_GROUPS`, `SAVED_MESSAGES_LIST`)
    // stay on takeLatest for exactly that reason: a fast typist only wants the last one.
    yield takeEvery(SHARE_MEDIA, MsgMiddleware.ShareMedia),
    yield takeLatest(REPORT_MSG, MsgMiddleware.ReportMsg),
    yield takeLatest(GLOBAL_SEARCH_CHATS_GROUPS, MsgMiddleware.GlobalSearchChatsGroups),
    yield takeEvery(MESSAGE_CHAT_CHANNEL, MsgMiddleware.MessageChatChannel),
    yield takeLatest(CREATE_GROUP, MsgMiddleware.CreateGroup),
    yield takeLatest(UNREAD_MESSAGE_DOT, MsgMiddleware.UnreadMessageDot),
    yield takeLatest(DELETE_MESSAGE, MsgMiddleware.DeleteMessage),
    yield takeLatest(ADD_USERS_GROUP, MsgMiddleware.AddUsersGroup),
    yield takeLatest(CREATE_GROUP_ADD_ID, MsgMiddleware.CreateGroupAddId),
    yield takeLatest(START_CALL, MsgMiddleware.StartCall),
    yield takeLatest(JOIN_CALL, MsgMiddleware.JoinCall),
    yield takeEvery(MISSED_CALL_HISTORY, MsgMiddleware.MissedCallHistory),
    yield takeEvery(RECENT_CALL_HISTORY, MsgMiddleware.RecentCallHistory),
    yield takeLatest(USERS_DATA, MsgMiddleware.UsersData),
    yield takeLatest(MULTIPLE_CALL_USERS_DATA, MsgMiddleware.MultipleCallUsersData),
    yield takeLatest(CALL_DETAILS, MsgMiddleware.CallDetails),
    yield takeLatest(CALL_SESSION, MsgMiddleware.CallSession),
    yield takeLatest(ACTIVE_GROUP_CALL, MsgMiddleware.ActiveGroupCall),
    yield takeLatest(CREATE_THREADS, MsgMiddleware.CreateThreads),
    yield takeEvery(THREAD_LISTING, MsgMiddleware.ThreadsListing),
    yield takeLatest(JOIN_THREADS, MsgMiddleware.JoinThreads),
    yield takeLatest(THREAD_DETAILS, MsgMiddleware.ThreadsDetails),
    yield takeLatest(UPLOAD_THREAD_MEDIA, MsgMiddleware.UploadThreadMedia),
    yield takeEvery(THREAD_CHAT_CHANNEL, MsgMiddleware.ThreadChatChannel),
    yield takeLatest(DELETE_USER_PROFILE, MsgMiddleware.DeleteUserProfile),
    yield takeLatest(TOGGLE_NOTIFICATIONS, MsgMiddleware.ToggleNotifications),
    yield takeEvery(NOTIFICATIONS_LISTS, MsgMiddleware.NotificationsLists),
    yield takeLatest(NOTIFICATIONS_UNREAD_COUNT, MsgMiddleware.NotificationsUnreadCount),
    // takeEvery, not takeLatest: opening two rows quickly must mark both read, and
    // takeLatest would cancel the first request.
    yield takeEvery(MARK_NOTIFICATIONS_READ, MsgMiddleware.MarkNotificationsRead),
    yield takeLatest(EDIT_USER_PROFILE, MsgMiddleware.EditUserProfile),
    yield takeLatest(DELETE_THREAD, MsgMiddleware.DeleteThread),
    yield takeLatest(DELETE_CHANNEL, MsgMiddleware.DeleteChannel),
    yield takeLatest(JOIN_GROUP, MsgMiddleware.JoinGroup),
    yield takeLatest(LEAVE_GROUP, MsgMiddleware.LeaveGroup),
    yield takeLatest(GROUP_MEMBERS, MsgMiddleware.GroupMembers),
    yield takeEvery(CHANNEL_MEMBERS_PAGE, MsgMiddleware.ChannelMembersPage),
    yield takeLatest(UPDATE_CREATE_GROUP, MsgMiddleware.UpdateCreateGroup),
    yield takeLatest(LAST_SEEN_TOGGLE, AppMiddleware.LastSeenToggle),
    yield takeLatest(CREATE_CONTACT, AppMiddleware.CreateContact),
    yield takeLatest(DELETE_CONTACT, AppMiddleware.DeleteContact),
    yield takeLatest(UPDATE_CONTACT, AppMiddleware.UpdateContact),
    yield takeLatest(LIST_CONTACTS, AppMiddleware.ListContacts),
    yield takeLatest(PASSCODE_TOGGLE, AppMiddleware.PasscodeToggle),
    yield takeLatest(VERIFY_PASSCODE, AppMiddleware.VerifyPasscode),
    yield takeLatest(UPDATE_PASSCODE, AppMiddleware.UpdatePasscode),
    // App-lock persistence. These carry no request — they exist so the durable copy
    // of the latch is written outside the reducer, which must stay pure.
    yield takeEvery(APP_LOCK_TRIGGER, AppMiddleware.PersistAppLock),
    yield takeEvery(APP_UNLOCK, AppMiddleware.PersistAppUnlock),
    yield takeLatest(CONTACT_SUPPORT, AppMiddleware.ContactSupport),
    // Channels. Retraction uses takeEvery, not takeLatest: an admin clearing several
    // messages in quick succession must land every one — takeLatest would cancel all
    // but the last, silently leaving the earlier messages in place.
    yield takeLatest(PROMOTE_CHANNEL_ADMINS, MsgMiddleware.PromoteChannelAdmins),
    yield takeLatest(DEMOTE_CHANNEL_ADMIN, MsgMiddleware.DemoteChannelAdmin),
    yield takeLatest(TRANSFER_CHANNEL_OWNERSHIP, MsgMiddleware.TransferChannelOwnership),
    yield takeLatest(REMOVE_CHANNEL_MEMBER, MsgMiddleware.RemoveChannelMember),
    yield takeEvery(RETRACT_MESSAGE, MsgMiddleware.RetractMessage),
    // Saved messages. takeEvery for the toggle, for the same reason as retraction:
    // starring three messages in a row must post three times, and takeLatest would
    // cancel the first two after their optimistic patch had already been applied —
    // leaving stars showing for bookmarks that were never saved.
    yield takeEvery(TOGGLE_SAVE_MESSAGE, MsgMiddleware.ToggleSaveMessage),
    // takeLatest for the list: a fast typist in the search box only wants the last one.
    yield takeLatest(SAVED_MESSAGES_LIST, MsgMiddleware.SavedMessagesList),
  ]);
}
